export default __webpack_public_path__ + "static/media/ReproHealth Nexus.fb95a54f.png";